import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { credentialsManagementRouter } from './routing/credentialsManagementRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import {
  apiKeyRequestApprovalsAccessControl,
  apiKeysAccessControl,
} from './access-control/credentialsManagementAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'credentials-management',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'credentials-management-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    partnerScoped: [credentialsManagementRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.Developer,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Manage API keys and authentication credentials',
          labelId: 'credentialsManagementDomain.apiKeysPage.title',
          route: 'credentials-management-api-keys',
          accessControl: apiKeysAccessControl,
          position: 2,
          positionNavV2: 2,
          inToolPermissions: [
            {
              slug: Permission.ConnectApiKeysModify,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.ConnectApiKeysModify,
            },
          ],
        },
        {
          type: 'item',
          llmDescription: 'Review and approve API key requests',
          labelId: 'credentialsManagementDomain.apiKeyApprovalRequestsPage.title',
          route: 'credentials-management-api-key-approval-requests',
          accessControl: apiKeyRequestApprovalsAccessControl,
          position: 3,
          positionNavV2: 3,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
  // NOTE TO DEV: run `pnpm ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
